// extracted by mini-css-extract-plugin
export default {"textarea":"FormTextarea_textarea__XgjYZ"};